/**
 * Returns the provided string with first letter capitalized
 *
 * @param string
 * @returns
 */
function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default capitalizeFirstLetter;
